import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { getPatientDataByURl, PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { GetPastSurgicalHX, SavePastSurgicalHX } from 'src/app/models/pastsurgicalhistory/pastsurgicalhistorymodel';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { IntakeService } from 'src/app/services/intake.service';
import { PastSurgicalService } from 'src/app/services/past-surgical.service';
import { IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-past-surgical-history',
  templateUrl: './past-surgical-history.component.html',
  styleUrls: ['./past-surgical-history.component.css']
})

export class PastSurgicalHistoryComponent implements OnInit {
  patientPersonalInfo: PatientPersonalInfo;
  keepGetting: boolean = true;
  curDate = new Date();
  intakeFieldsSetting: IntakeFieldsSetting = new IntakeFieldsSetting();
  newPatientPersonalInfo: getPatientDataByURl;
  landFromCheckin: any;
  isFromNewPatient: boolean = false;
  reasonName: any;
  PracticeCode: any;
  PatientAccount: any;
  FIRSTNAME: any;
  LASTNAME: any;
  constructor(private translateService: TranslateService, private changeRef: ChangeDetectorRef, private service: PastSurgicalService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router,
    private datepipe: DatePipe, private intakeService: IntakeService) {


    this.landFromCheckin = localStorage.getItem("landFrom");
    console.log("landFromCheckin in past-surgical component", this.landFromCheckin);
    if (this.landFromCheckin == 'drsiteintake' || this.landFromCheckin == 'new_patient') {
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      console.log("info in intake form PatientInfo", info);
      this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
     // console.log("newPatientPersonalInfo", this.newPatientPersonalInfo);
      this.reasonName = this.newPatientPersonalInfo.reasonName;
      this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
      this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
      this.FIRSTNAME = this.newPatientPersonalInfo.firstName;
      this.LASTNAME = this.newPatientPersonalInfo.lastName;
    }
    else {

      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
      //console.log("info in intake form PersonalInfo else", this.patientPersonalInfo);
      //this.reasonName = this.patientPersonalInfo.REASON_NAME;
      this.PracticeCode = this.patientPersonalInfo.PRACTICE_CODE;
      this.PatientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT
      this.FIRSTNAME = this.patientPersonalInfo.FIRSTNAME;
      this.LASTNAME = this.patientPersonalInfo.LASTNAME;
    }

    //this.patientPersonalInfo = this.phrUtils.decrypt(localStorage.getItem('PersonalInfo')) as PatientPersonalInfo;      
    if (this.intakeService.subsNextStepSurgical == undefined) {
      this.intakeService.invokeNextStepSurgical.subscribe((name: string) => {
        this.router.navigateByUrl("patient/intake/past-hospitalization-history");
      });
    }
    this.intakeFieldsSetting = this.phrUtils.decrypt(localStorage.getItem("intakeformsetting")) as IntakeFieldsSetting;
  }

  async ngOnInit() {
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.phrUtils.setTitle('Historial Quirúrgico Pasado');
      } else if (language === 'hi') {
        this.phrUtils.setTitle('पिछला सर्जिकल इतिहास');
      }
      else if (language === 'ur') {
        this.phrUtils.setTitle('ماضی کی سرجیکل ہسٹری');
      }
      else {
        this.phrUtils.setTitle('Past Surgical History');
      }
    });
    this.spinner.show();
    await this.getPastSurgicalHX();
    this.spinner.hide();
  }

  pastSHX: GetPastSurgicalHX[] = [];
  async getPastSurgicalHX(): Promise<any> {
    await this.service.getPastSurgicalHistory(this.PatientAccount, this.PracticeCode)
      .toPromise()
      .then((data: any) => {
        this.keepGetting = true;
        if (data && data.statusCode == 200) {
          if (data.data.length > 0) {
            this.pastSHX = data.data as GetPastSurgicalHX[];
            this.pastSHX.map(item => {
            });
          }
        }
      })
      .catch((err: any) => {
        this.keepGetting = false;
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        // this.phrUtils.showError("Service is not available, please try later.");
      });
  }

  isDateError: boolean = false;
  onChangeDate(e: any) {
    let cDate = new Date(this.curDate);
    let d: Date = new Date(e.target.value);
    if (d > cDate) {
      this.isDateError = true;
    } else {
      this.isDateError = false;
    }
  }
  //replace min date limit 1970 with 1901 
  focusOutFunction(e: any, type: any) {
    if (this.savepastHHX.surgeryDate) {
      if (type == 0) {
        let date = this.savepastHHX.surgeryDate.split('-');
        if (Number(date[0]) < 1901) {
          date[0] = '1901';
        }
        this.savepastHHX.surgeryDate = date[0] + '-' + date[1] + '-' + date[2];
      }
      else if (type == 1) {
        let date = this.updatePastSurg.surgerY_DATE.split('-');
        if (Number(date[0]) < 1901) {
          date[0] = '1901';
        }
        this.updatePastSurg.surgerY_DATE = date[0] + '-' + date[1] + '-' + date[2];
      }
    }
  }

  onNoKnownPastSurgicalHiistory() {
    this.spinner.show();
    this.service.noKnownPastHospHistory(this.PatientAccount, this.PracticeCode)
      .subscribe((res: any) => {
        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == "success") {
          let text = "No known family history is set.";
          this.translateService.get('Alerts.family_history_no_known').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showInfo(text);
          //this.phrUtils.showSuccess("No known family history is set.");
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Service is not available, please try later.");
          this.spinner.hide();
        });
  }

  modalPastSurgHX() {
    if (this.pastSHX.length == 5) {
      let text = "Maximum 5 past surgical records can be added.";
      this.translateService.get('Alerts.psh_maximum_5_PSR_can_be_added').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showInfo(text);
      //this.phrUtils.showInfo("Maximum 5 past surgical records can be added.");
      return;
    }
    this.isSurgeryNameNull = false;
    $('#newPastSurg').modal('show');
  }

  setNoKnownPastSurgHX() {
    //The mention API does't exsit that's way the error message occured instead of calling api move to the next tab when the history is no Known
    let text = "No known surgical history is set.";
    this.translateService.get('Alerts.noknown_psh').subscribe((translation: string) => {
      text = translation;
    });
    //this.phrUtils.showInfo(text);
    //this.phrUtils.showSuccess("No known surgical history is set.");
    this.intakeService.onNoKnown();
  }

  savepastHHX: SavePastSurgicalHX = new SavePastSurgicalHX();
  isSurgeryNameNull: boolean = false;
  savePastSurgicalHX() {
    // if (!this.patientPersonalInfo || !this.newPatientPersonalInfo) {
    //   return;
    // }
    if (this.savepastHHX.surgeryName) {
      this.savepastHHX.patientAccount = this.PatientAccount;
      this.savepastHHX.practiceCode = this.PracticeCode;
      this.savepastHHX.pastSurgicalHistoryStructureReconcileId = "";
      this.savepastHHX.createdBy = this.PatientAccount;
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';
      this.translateService.use(lang);
      this.savepastHHX.language = lang;
    }
    else {
      this.isSurgeryNameNull = true;
      return;
    }

    if (this.isDateError) {
      return;
    }

    this.spinner.show();
    this.service.SaveUpdatePastSurgicalHistory(this.savepastHHX)
      .subscribe((res: any) => {
        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == "success") {
          this.savepastHHX = new SavePastSurgicalHX();
          this.getPastSurgicalHX();
          let text = "Saved successfully.";
          this.translateService.get('Alerts.psh_saved_successfully').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showSuccess(text);
          //this.phrUtils.showSuccess("Saved successfully.");
          $('#newPastSurg').modal('hide');
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Service is not available, please try later.");
          this.spinner.hide();
        });
  }

  reset() {
    this.savepastHHX = new SavePastSurgicalHX();
    this.isDateError = false;
    this.changeRef.markForCheck();
  }

  updatePastSurg: GetPastSurgicalHX = new GetPastSurgicalHX();
  editPastSurg(pastSurg: any) {
    this.updatePastSurg = pastSurg;
    if (this.updatePastSurg.surgerY_DATE) {
      this.updatePastSurg.surgerY_DATE = String(this.datepipe.transform(this.updatePastSurg.surgerY_DATE, 'yyyy-MM-dd'));
    }
    this.isUpdateSurgicalNameNull = false;
    $('#editPastSurg').modal('show');
  }

  inputSurgeryName(event: any, type: any) {

    if (event.target.value.length > 0) {
      if (type == 'add')
        this.isSurgeryNameNull = false;
      else
        this.isUpdateSurgicalNameNull = false;
    }
    else {
      if (type == 'add')
        this.isSurgeryNameNull = true;
      else
        this.isUpdateSurgicalNameNull = true;
    }
  }

  isUpdateSurgicalNameNull: boolean = false;
  updatePastSurgHX() {
    let savePSHX = new SavePastSurgicalHX();
    if (this.updatePastSurg.surgerY_NAME) {
      savePSHX.patientAccount = this.PatientAccount;
      savePSHX.practiceCode = this.PracticeCode;
      savePSHX.createdBy = this.PatientAccount;
      savePSHX.surgeryDate = this.updatePastSurg.surgerY_DATE || '';
      savePSHX.surgeryName = this.updatePastSurg.surgerY_NAME;
      savePSHX.surgeryPlace = this.updatePastSurg.surgerY_PLACE;
      savePSHX.postSurgeryComplications = this.updatePastSurg.posT_SURGERY_COMPLICATIONS;
      savePSHX.pastSurgicalHistoryStructureReconcileId = this.updatePastSurg.pasT_SURGICAL_HISTORY_STRUCTURE_ID;
    }
    else {
      this.isUpdateSurgicalNameNull = true;
      return;
    }
    if (this.isDateError) {
      return;
    }
    this.spinner.show();
    this.service.SaveUpdatePastSurgicalHistory(savePSHX)
      .subscribe((res: any) => {
        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == "success") {
          this.updatePastSurg = new GetPastSurgicalHX();
          this.getPastSurgicalHX();
          let text = "Updated successfully.";
          this.translateService.get('Alerts.psh_updated_successfully').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showSuccess(text);
          //this.phrUtils.showSuccess("Updated successfully.");
          $('#editPastSurg').modal('hide');
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Service is not available, please try later.");
          this.spinner.hide();
        });
  }

  //  ************* delete functions *************
  deletePastSurg: GetPastSurgicalHX = new GetPastSurgicalHX;
  deletePastSurgery(pastSG: GetPastSurgicalHX) {
    this.deletePastSurg = pastSG;
    $('#delPastSurg').modal('show');
  }

  async DeleteSurgicalHX() {
    let dto = {
      pastSurgicalHistoryStructureId: String(this.deletePastSurg.pasT_SURGICAL_HISTORY_STRUCTURE_ID),
      patientAccount: this.PatientAccount,
      practiceCode: this.PracticeCode,
      modifiedBy: this.FIRSTNAME + ' ' + this.LASTNAME,
      deleted: true
    }

    this.spinner.show();
    await this.service.deletePastSurgicalHistory(dto)
      .toPromise()
      .then((data: any) => {
        this.spinner.hide();
        if (data && data.statusCode == 200) {
          let text = "Deleted successfully.";
          this.translateService.get('Alerts.psh_deleted_successfully').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showSuccess(text);
          // this.phrUtils.showSuccess("Deleted successfully.","SUCCESS");
          $('#delPastSurg').modal('hide');
          this.pastSHX.forEach((item, index) => {
            if (item === this.deletePastSurg) {
              this.pastSHX.splice(index, 1);
            }
          });
        }
      })
      .catch((err: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
      });
  }
}
